import React, { useContext } from "react";

import { Button, Icon } from "@culturehq/components";
import { Trans } from "app/utils";
import { CreatomateContext } from "../../../../contexts/VideoStudioContext";

interface StylesButtonProps {
  onShowStyles: () => void;
}

const StylesButton: React.FC<StylesButtonProps> = ({ onShowStyles }) => {
  const { data: { pendingSubtitle } } = useContext(CreatomateContext);

  return (
    <Button inverted onClick={onShowStyles} className="Styles-Subtitles-btn" disabled={!!pendingSubtitle}>
      <Icon icon="paint-bucket" /><Trans>Styles</Trans>
    </Button>
  );
};

export default StylesButton;
